import { Star } from './Star';

type Props = {
    rating?: number;
    maxRating?: number;
};

export const StarRating = ({ rating = 0, maxRating = 5 }: Props) => {
    return (
        <div className="flex items-center">
            {Array.from({ length: maxRating }).map((_, index) => (
                <Star key={index} active={index < rating} />
            ))}
        </div>
    );
};
